import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Checkbox } from 'redux-form-material-ui';

// TODO: Combine sms and email checkbox component to be more generic when time is not a constraint
const MarketingSMSField = props => (
  <Field
    name="wantsMarketingSMS"
    component={ Checkbox }
    className={ props.className }
    label= "I would like to receive iFit SMS/text messages about promotions, features, and more."
  />
);

MarketingSMSField.propTypes = {
  className: PropTypes.string,
};

export default MarketingSMSField;